<template>
  <div class="you-like">
    <div class="like-header">
      <div class="header-title">
        <img
          @click="$router.go(-1)"
          src="@/assets/images/like-back-icon.png"
          alt=""
        />
        <h1>我喜欢：{{ gameTypeTitle }}</h1>
      </div>
      <div class="header-right-slot" @click="youLikeDialogVisible = true">
        <img src="@/assets/images/switch-icon.png" alt="" />
        <span>切换类型</span>
      </div>
    </div>

    <div class="game-container">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <div class="game-list-container">
          <div class="game-item" v-for="(info, i) in gameList" :key="i">
            <div class="game-video-box" v-if="info.videoUrl">
              <video
                class="game-video"
                controls
                :src="info.videoUrl"
                :poster="info.videoImgUrl"
              >
                <!-- <source src="shanghai.mp4" type="video/mp4"> -->
              </video>
            </div>
            <div class="game-item-main">
              <div class="game-item-content" @click="jumpDetail(info)">
                <img class="game-logo" :src="info.logo_url" alt="" />
                <div class="game-info">
                  <div class="game-info-title">
                    <h1>{{ info.game_name }}</h1>
                    <span>{{ info.discount }}</span>
                  </div>
                  <div class="game-info-desc">
                    <div class="game-info-gift">
                      <span v-if="info.wealf">福利</span>
                      <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                      <span v-if="info.isBTgame">变态特权</span>
                      <span v-if="info.waterMark == 1">专属折扣</span>
                      <span
                        v-if="
                          info.havaGift == 0 &&
                          !info.isBTgame &&
                          !info.wealf &&
                          info.waterMark == 0
                        "
                        >{{ info.title }}</span
                      >
                    </div>
                    <div class="star" v-if="info.starInfo">
                      <img
                        :key="star"
                        v-for="star in info.starInfo.allStar"
                        src="@/assets/images/star_all.png"
                        alt=""
                      />
                      <img
                        :key="star+999"
                        v-for="star in info.starInfo.halfStar"
                        src="@/assets/images/star_half.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="game-tag">
                    <span v-for="tag in info.formatGameType" :key="tag">{{
                      tag
                    }}</span>
                    <span class="other-tag">{{ info.openServerDate }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="game-item-operate">
                <span @click="doOperate(info, 'recharge')">充值</span>
                <span @click="doOperate(info, 'download')">下载</span>
              </div> -->
              <operateBtns :gameInfo="info" @doOperate="doOperate" />
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <youLikeDialog
      v-if="youLikeDialogVisible"
      v-model="youLikeDialogVisible"
      :get-container="getContainer"
      :userLikes="userLikes"
      @setUserLikeEvent="getUserLikeEvent"
    />

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import youLikeDialog from "@/components/youLikeDialog";
import gamePlatPopup from "@/components/GamePlatPopup.vue";
import mixins from "@/mixin/game.js";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins],
  components: {
    youLikeDialog,
    gamePlatPopup,
    operateBtns
  },
  data() {
    return {
      youLikeDialogVisible: false,
      userLikes: [],
      gameTypeTitle: "",
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      gameList: [],
      btnType: "",
      gameInfo: {},
      gamePlatPopupVisible: false,
    };
  },
  computed: {
    ...mapGetters(["uuid", "isLogin"]),
  },
  async mounted() {
    await this.getUserLikeList();
    this.onLoad();
  },
  methods: {
    getContainer() {
      return document.querySelector(".you-like");
    },
    /**
     * 获取用户喜好
     */
    async getUserLikeList() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getUserLikeList.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        const { userLike } = data;
        this.userLikes = userLike || [];
        if (this.userLikes.length) {
          const { gameType, typeName } = this.userLikes[0];
          this.gameTypeTitle = typeName;
          this.gameType = gameType;
        } else {
          this.gameTypeTitle = "都喜欢";
          this.gameType = "ALL";
        }
      } catch (err) {
        this.$toast(err.message);
      }
    },

    async getUserLikeEvent() {
      await this.getUserLikeList();
      this.resetList();
      this.onLoad();
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.gameList = []; // 清空当前列表
      this.totalCount = 0;
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.userLikeGameQr();
      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },
    /**
     * 获取猜你喜欢游戏列表
     */
    async userLikeGameQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGuessYourLikeList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            searchParams: JSON.stringify({
              uuid: this.uuid,
              gameType: this.gameType,
            }),
            appType: 'WM'
          }
        );
        let list = this.gameInit(data);
        return {
          data: list,
          totalCount: totalCount,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },

    doOperate(scope, chennel) {
      // if(!this.isLogin) {
      //   this.$router.push('/login')
      //   return
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id
      }
      this.gamePlatPopupVisible = true;
    },

    jumpDetail(info) {
      this.$router.push({
        path: "/detail",
        query: {
          gameId: info.game_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.you-like {
  .like-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 22px 20px 22px 30px;
    position: sticky;
    top: 0;
    z-index: 1000;

    .header-title {
      display: flex;
      align-items: center;
      img {
        width: 23px;
        height: 42px;
        margin-right: 20px;
      }
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
      }
    }
    .header-right-slot {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        margin-right: 5px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #a2a2a2;
      }
    }
  }
  .game-container {
    .game-list-container {
      padding: 40px 40px 0 40px;

      .game-item {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }

        .game-video-box {
          width: 690px;
          height: 387px;
          margin-bottom: 30px;
        }
        .game-video {
          width: 690px;
          height: 387px;
        }
      }

      .game-item-main {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      .game-item-content {
        display: flex;
        align-items: center;

        .game-logo {
          width: 132px;
          height: 132px;
          margin-right: 20px;
        }
        .game-info {
          .game-info-title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            h1 {
              max-width: 300px;
              font-weight: 600;
              font-size: 32px;
              color: #000000;
              line-height: 45px;
              margin-right: 6px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            span {
              display: block;
              padding: 5px 5px;
              font-weight: 600;
              font-size: 22px;
              color: #ffffff;
              height: 30px;
              background: #ff7a3e;
              border-radius: 4px;
            }
          }
          .game-info-desc {
            width: 390px;
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .game-info-gift {
              span {
                padding: 4px 12px;
                background: #f8f8f8;
                border-radius: 4px;
                border: 1px solid #f8f8f8;
                font-weight: 500;
                font-size: 18px;
                color: #a2a2a2;
                margin-right: 8px;
              }
            }
            .star {
              display: flex;
              align-items: center;
              img {
                width: 24px;
                margin-right: 8px;
              }
            }
          }
          .game-tag {
            span {
              padding: 2px 6px;
              // background: #f8f8f8;
              border-radius: 22px;
              border: 0px solid #d2d2d2;
              font-weight: 600;
              font-size: 20px;
              color: #a2a2a2;
              // margin-right: 18px;
            }
            .other-tag {
              color: #ffbe70;
            }
          }
        }
      }

      .game-item-operate {
        span {
          display: block;
          width: 105px;
          height: 50px;
          border-radius: 25px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          line-height: 50px;
          text-align: center;

          &:first-child {
            color: #ffffff;
            background: #ff7a3e;
            margin-bottom: 23px;
          }
          &:last-child {
            border: 2px solid #ff7a3e;
            color: #ff7a3e;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/youLike/index.vue